import Quill, {Module} from 'quill';
import { SPECIAL_CHARACTERS } from './special-characters.model';

class SpecialCharacters  extends Module {
  public quill: Quill;

  constructor(quill: Quill, options: any) {
    super(quill, options);
    this.quill = quill;
    this.options = options;
    const toolbar = quill.getModule('toolbar') as any;
    if (!toolbar) {
      throw new Error(
        'SpecialCharacters requires the "toolbar" module to be included too',
      );
    }

    this.createButton(toolbar.container);
  }

  createButton(toolbarContainer: HTMLElement) {
    const buttonContainer = document.createElement('span');
    buttonContainer.classList.add('ql-formats');

    const button = document.createElement('button');
    button.classList.add('ql-special-character');
    button.innerHTML = '&Omega;'; // Special character icon
    button.title = 'Insert Special Character';

    buttonContainer.appendChild(button);
    toolbarContainer.appendChild(buttonContainer);

    button.addEventListener('click', () => this.showDropdown(button));
  }

  showDropdown(button: HTMLButtonElement) {
    const dropdown = document.createElement('div');
    dropdown.classList.add('ql-special-dropdown');
    SPECIAL_CHARACTERS.forEach(char => {
      const item = document.createElement('button');
      item.innerHTML = char.symbol;
      item.title = char.name;
      item.addEventListener('click', () => this.insertCharacter(char.symbol));
      dropdown.appendChild(item);
    });

    document.body.appendChild(dropdown);

    const rect = button.getBoundingClientRect();
    dropdown.style.top = `${rect.bottom + window.scrollY}px`;
    dropdown.style.left = `${rect.left + window.scrollX}px`;


    const closeDropdown = () => {
      if (document.body.contains(dropdown)) {
        document.body.removeChild(dropdown);
      }
      document.removeEventListener('click', closeDropdown);
    };

    setTimeout(() => {
      document.addEventListener('click', closeDropdown);
    }, 10);
  }

  insertCharacter(symbol: string) {
    const range = this.quill.getSelection()?.index || this.quill.getLength();
    if (range) {
      this.quill.insertText(range, this.decodeHTMLEntity(symbol), 'user');
      this.quill.setSelection(range + 1, 0);
    }
  }

  decodeHTMLEntity(entity: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = entity;
    return textarea.value;
  }
}

export default SpecialCharacters;
